import React from 'react';
import { Link } from 'react-router-dom';
import { GovEmpty, GovFlex, GovIcon } from '@gov-design-system-ce/react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import {
	DataBoxFolderType,
	getDataBoxIcon,
	getDataBoxTypeLabel,
} from '@gov-nx/module/data-box';
import { PageCode, useDashboardContextInstance } from '@gov-nx/module/page';
import { ContentLayout } from '@gov-nx/ui/web';
import { pageRouteResolver } from '@gov-nx/web';
import { SideBoxHeader } from '../../SideBox/SideBoxHeader';
import { UnreadMessagesSkeleton } from './UnreadMessagesSkeleton';

export const DashboardUnreadMessagesWidget = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);

	const {
		unreadMessages,
		isLoading,
		dataBoxDateUtils: { getMessageDateLabel },
	} = useDashboardContextInstance();

	return (
		<ContentLayout customClasses="p-0! mb-(--templates-margin-l)!">
			<SideBoxHeader link={PageCode['datove-schranky']}>
				<GovIcon
					name="datovka-fill"
					type="templates"
					slot="icon"
				/>
				<span>{tn('box-neprectene.neprectene-zpravy')}</span>
			</SideBoxHeader>

			{isLoading ? (
				<UnreadMessagesSkeleton />
			) : !unreadMessages.length ? (
				<GovEmpty
					icon={
						<GovIcon
							name="communication"
							type="complex"
							slot="icon"
						/>
					}
					headline={<p slot="headline">{tn('box-neprectene.nic-neuniklo')}</p>}
					size="s"
					align="center">
					<p>{tn('box-neprectene.vsechny-prectene')}</p>
				</GovEmpty>
			) : (
				<ul className="gov-list--plain mt-0! pb-(--templates-margin-m)">
					{unreadMessages.map((message) => (
						<li
							className="border-b border-(--border-subtlest) [ last-of-type:border-b-0 ]"
							key={message.datovaZpravaId}>
							<Link
								to={pageRouteResolver('datove-schranky.schranka.zprava', {
									dataBoxId: message.prijemceId,
									folderType: DataBoxFolderType.Received,
									messageId: message.datovaZpravaId,
								})}
								className="anim-bg-hover flex gap-(--spacing-s-nudge) py-(--spacing-m) px-(--spacing-m-nudge) no-underline! ">
								<GovIcon
									name="notification"
									type="templates"
									slot="icon"
									className="relative top-[5px] w-3! h-3! text-(--button-solid-secondary)!"
								/>
								<GovFlex
									gap="s"
									direction="column"
									className="w-full">
									<GovFlex
										justifyContent="space-between"
										gap="s"
										responsive="false">
										<div className="text-body-m-bold">
											{message.odesilatelNazev}
										</div>
										<span className="relative top-[3px] text-body-xs text-(--text-secondary)">
											{getMessageDateLabel(message.datumACasDodani as string)}
										</span>
									</GovFlex>
									<div className="text-body-s text-(--text-secondary)">
										{message.vec}
									</div>
									<div className="flex gap-(--spacing-s) text-body-xs text-(--text-secondary)">
										<GovIcon
											name={getDataBoxIcon(message.typSchranky)}
											type="templates"
											slot="icon"
											size="s"
											className="mt-0.5"
										/>
										{message.prijemceNazev} -{' '}
										{getDataBoxTypeLabel(message.typSchranky, tn)}
									</div>
								</GovFlex>
							</Link>
						</li>
					))}
				</ul>
			)}
		</ContentLayout>
	);
};
